module.exports = __webpack_public_path__ + "img/evnt.598ca704.jpg";